/**
 * Picks vendor JSON-RPC `extNotification` handling for `@agentclientprotocol/sdk` stdio clients.
 * Agent-specific logic lives in per-agent modules; routing is a switch here (not inside handlers).
 */

import { createKiroSdkExtNotificationHandler } from '../kiro-sdk-ext-notifications.js';

export type SdkStdioExtNotificationHandler = (method: string, params: unknown) => Promise<void>;

const noopExtNotification: SdkStdioExtNotificationHandler = async () => {};

/**
 * Returns the extension-notification handler for this backend agent type.
 * Unknown agents get a no-op so vendor notifications never throw (-32601) in the SDK.
 */
export function createSdkStdioExtNotificationHandler(options: {
  backendAgentType: string | undefined | null;
  onSessionUpdate?: (payload: unknown) => void;
}): SdkStdioExtNotificationHandler {
  const { backendAgentType, onSessionUpdate } = options;
  // `kiro-acp` matches `BACKEND_LOCAL_AGENT_TYPE` in `kiro-acp-client.ts` (avoid importing it here: that module pulls in sdk-stdio).
  switch (backendAgentType) {
    case 'kiro-acp':
      return createKiroSdkExtNotificationHandler({ onSessionUpdate });
    default:
      return noopExtNotification;
  }
}
